// React Imports
import { useParams } from "react-router-dom";
// Custom
import VegzelmaEntry from "./VegzelmaEntry";
import YuflymaEntry from "./YuflymaEntry";
import {ZymfentraEntry} from "./ZymfentraEntry";
import AdalimumabAATYEntry from "./AdalimumabAaty";
import {SteqeymaEntry} from "./SteqeymaEntry";
const Entry = () => {
  const { category } = useParams();

  return (
    <div> 
      {category === "vegzelma" ? (
        <VegzelmaEntry />
      ) : category === "yuflyma" ? (
        <YuflymaEntry />
      ) : category === "zymfentra" ? (
        <ZymfentraEntry />
      ) : category === "adalimumab" ? (
        <AdalimumabAATYEntry />
      ) : category === "steqeyma" ? (
        <SteqeymaEntry />
      ) : null}
    </div>
  );
};

export default Entry;
